import { useLoaderData, useNavigate } from 'react-router-dom';
import { useMemo, useCallback } from 'react';
import PaginatedCards from '../paginatedCards/PaginatedCards';
import './latestads.scss';

const LatestAds = () => {
  const data = useLoaderData();
  const navigate = useNavigate();

 const handlePostClick = useCallback( (url) => { setTimeout(() => { navigate(url); }, 3000); }, [navigate] );

  const sortedPosts = useMemo(() => {
    if (!data?.postResponse?.data || !Array.isArray(data.postResponse.data)) {
      console.warn('No data or invalid format in loader');
      return [];
    }
    return [...data.postResponse.data].sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
  }, [data?.postResponse?.data]);

  return (
    <div className="latestAdsContainer">
      <h1>New ads</h1>
      {sortedPosts.length > 0 ? (
        <PaginatedCards key={sortedPosts.length} posts={sortedPosts} onPostClick={handlePostClick} />
      ) : (
        <div>No ads available</div>
      )}
    </div>
  );
};

export default LatestAds;

